import { configureStore } from '@reduxjs/toolkit';
import formInstancesReducer from './formInstancesSlice';

const store = configureStore({
  reducer: {
    formInstances: formInstancesReducer,
  },
});

export default store;
